import { useEffect, useRef } from 'react';
import { gtag, GTM_ID as gtmId, GTAG_ID as gtagId } from '../util';

const GoogleTagManager = () => {
  
  const gtmScriptRef = useRef(null);
  const gtagScriptRef = useRef(null);

  // GTM useEffect
  useEffect(() => {
    if (!gtmId || gtmScriptRef.current) return;

    // Push GTM start event
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    // Create and append GTM script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    gtmScriptRef.current = script;
    
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    
    if (document.body && document.body.firstChild) {
      document.body.insertBefore(noscript, document.body.firstChild);
    }

    console.debug(`GTM initialized with ID: ${gtmId}`);
  }, []);

  // gtag useEffect
  useEffect(() => {
    if (!gtagId || gtagScriptRef.current) return;

    // Set global gtag function
    window.gtag = gtag;
    
    // Initialize gtag
    gtag('js', new Date());
    gtag('config', gtagId);

    // Create and append gtag script
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
    gtagScriptRef.current = gtagScript;
    
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(gtagScript, firstScript);
    }

    console.debug(`gtag initialized with ID: ${gtagId}`);
  }, []);

  return null;
};

export default GoogleTagManager;